import { Injectable } from '@angular/core';
import {
    AccountingCatalog,
    FavRequest,
    FelGroup,
    OrdProfile,
    SelectProfileRequest,
    SelectProfileResult,
} from '@delab/ngx-gen-ts-ixserv/models';
import { map, Observable } from 'rxjs';
import { AccountingCatalogDto } from 'src/.api-client/models/accounting-catalog-dto';
import { FelGroupDto } from 'src/.api-client/models/fel-group-dto';
import { OrdProfileDto } from 'src/.api-client/models/ord-profile-dto';
import { SelectProfileResultDto } from 'src/.api-client/models/select-profile-result-dto';
import { OrderProfileApiService } from 'src/.api-client/services/order-profile-api.service';

@Injectable({
    providedIn: 'root',
})
export class OrderProfileService {
    constructor(private _orderProfileApiService: OrderProfileApiService) {}

    public getAccessibleProfiles(prtID: number): Observable<OrdProfile[]> {
        return this._orderProfileApiService.orderProfileGetAccessibleProfiles({ prtID: prtID }).pipe(
            map((value: OrdProfileDto[]) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
                return value.map((value: OrdProfileDto) => new OrdProfile(value));
            }),
        );
    }

    public getFelGroups(): Observable<FelGroup[]> {
        return this._orderProfileApiService.orderProfileGetFelGroups().pipe(
            map((value: FelGroupDto[]) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
                return value.map((value: FelGroupDto) => new FelGroup(value));
            }),
        );
    }

    public createWksFavorite(favRequest: FavRequest): Observable<void> {
        return this._orderProfileApiService.orderProfileCreateWksFavorite({ body: favRequest }).pipe(
            map((value) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
            }),
        );
    }

    public getProfileInfos(prfIds: number[]): Observable<OrdProfile[]> {
        return this._orderProfileApiService.orderProfileGetProfileInfos({ body: prfIds }).pipe(
            map((value: OrdProfileDto[]) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
                return value.map((value) => new OrdProfile(value));
            }),
        );
    }

    public deleteFavorite(favID: number): Observable<void> {
        return this._orderProfileApiService.orderProfileDeleteFavorite({ favID }).pipe();
    }

    public getAccountingCatalogs(): Observable<AccountingCatalog[]> {
        return this._orderProfileApiService.orderProfileGetAccountingCatalogs().pipe(
            map((value: AccountingCatalogDto[]) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
                return value.map((value: AccountingCatalogDto) => new AccountingCatalog(value));
            }),
        );
    }

    public getSelectedProfileDetails(selectProfileRequest: SelectProfileRequest): Observable<SelectProfileResult | undefined> {
        return this._orderProfileApiService.orderProfileGetSelectedProfileDetails({ body: selectProfileRequest }).pipe(
            map((value: SelectProfileResultDto) => {
                if (typeof value === 'undefined') {
                    throw Error();
                }
                return new SelectProfileResult(value);
            }),
        );
    }
}
